//const BASE_URL_API = 'https://devapi-opfg.dl6.in/';
const BASE_URL_API = 'https://api-opfg.dl6.in/';
// const BASE_URL_API = 'https://cdnopfg-data.dl6.in/';
const IMAGE_PATH = 'https://cdn-opfg.dl6.in/public/img';
//const IMAGE_PATH = '/collabwithgov/img';
const BASE_URL_OPENFORGE = 'https://openforge.gov.in';
//const BASE_URL_OPENFORGE = 'https://devofv15.dl6.in';
const API_TIMEOUT = 5000;
const CLIENT_ID = 'OpenForgeFastAPI'; // Do not change value
const CLIENT_SECRET = '4f21c0f82417cc2df854dfdb10c3971b'; // Do not change value
const DATA_DECRYPTION_KEY = '8cbaea915f0a7601';
//const VISITOR_COUNT_API = 'https://acsapi-beta.dl6.in/';
const VISITOR_COUNT_API = 'https://acsapi.digilocker.gov.in/';
const CERTIFICATE_DOWNLOAD_API = 'https://devapi-opfg.dl6.in/';
const SOP_CDN_PATH = 'https://cdn-opfg.dl6.in/public/resource/SoP_CodeforGov.pdf';
const USER_MANUAL_CONTRIBUTOR_CDN_PATH = 'https://cdn-opfg.dl6.in/public/resource/User_Manual_Contributor.pdf';
const GIGW_Web_Accessibility = 'https://cdn-opfg.dl6.in/public/resource/GIGW_3.0_Web_Assesibility.xlsx';
const USER_MANUAL_TASK_CREATOR_CDN_PATH = 'https://cdn-opfg.dl6.in/public/resource/User_Manual_Task_Creator.pdf';
const CDN_ELK_URL = 'https://cdnopfg-data.dl6.in';
// const CDN_ELK_URL = 'https://dev-cdnopfg-data.dl6.in';

const IMAGE_PATH_Leader='https://cdn-opfg.dl6.in';
const AES_SECRET_KEY = 'r4!#5WBOz{]?yk!Hz#R8/h6Au}9kr03d';
const DEFAULT_USER_IMAGE = "https://img1.digitallocker.gov.in/assets/img/icons/user_icon.svg"
export { 
    BASE_URL_API, 
    IMAGE_PATH, 
    BASE_URL_OPENFORGE, 
    API_TIMEOUT, 
    CLIENT_ID, 
    CLIENT_SECRET, 
    DATA_DECRYPTION_KEY,
    VISITOR_COUNT_API,
    CERTIFICATE_DOWNLOAD_API,
    SOP_CDN_PATH,
    USER_MANUAL_CONTRIBUTOR_CDN_PATH,
    USER_MANUAL_TASK_CREATOR_CDN_PATH,
    CDN_ELK_URL,
    IMAGE_PATH_Leader,
    AES_SECRET_KEY,
    GIGW_Web_Accessibility,
    DEFAULT_USER_IMAGE
};
